import axios from 'axios';

// Same-origin override for Lab sandbox previews. Any request coming from
// preview-<id>.atdecisionhub.net uses same-origin API calls so that the
// per-sandbox dispatcher (Phase 51.L Step B4.4) routes /api/* to the
// sandbox backend instead of the shared production backend. Prod + local
// dev still honor REACT_APP_BACKEND_URL as before.
const _isSandboxPreview =
  typeof window !== 'undefined' &&
  /^preview-[a-z0-9]+\./i.test(window.location.hostname);

const BACKEND_URL = _isSandboxPreview
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Long default timeout so LLM-backed endpoints (/chat, /coach/*, /decision)
// never get cut off by the axios client while Claude is still thinking.
const api = axios.create({ baseURL: API, timeout: 180000 });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('atde_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retry GETs on 429 / 5xx / network error (max 2 attempts, jittered backoff).
// POSTs are NOT retried (idempotency risk).
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config || {};
    const status = err?.response?.status;
    const retriable = status === 429 || status === 503 || status === 502 || status === 504 || (!err.response && err.message);
    if (cfg && (cfg.method || 'get').toLowerCase() === 'get' && retriable) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      if (cfg.__retryCount <= 2) {
        const delay = 300 * cfg.__retryCount + Math.random() * 200;
        await new Promise((res) => setTimeout(res, delay));
        return api(cfg);
      }
    }
    if (status === 401) {
      sessionStorage.removeItem('atde_token');
      if (window.location.pathname !== '/login') {
        // Defer to next tick so we never call setState during a render cycle
        // (that triggers the "uncaught runtime error" overlay).
        setTimeout(() => { window.location.href = '/login'; }, 0);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
